// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader___11k5t"};